import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

// COMPONENTES GLOBALES
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// PÁGINAS
import Home from './pages/Home';
import Blog from './pages/Blog';
import Contacto from './pages/Contacto';
import Cotizador from './pages/Cotizador';
import Juridico from './pages/Juridico';
import Nomina from './pages/Nomina';
import RecursosHumanos from './pages/RecursosHumanos';
import SeleccionPersonal from './pages/SeleccionPersonal';
import ServiciosIndependientes from './pages/ServiciosIndependientes';
import SST from './pages/SST';
import TrabajaConNosotros from './pages/TrabajaConNosotros';
import EstructuraOrganizacional from './pages/EstructuraOrganizacional';
import Politica from './pages/Politica';
import PortafolioServicios from './pages/PortafolioServicios';
import NotFound from './pages/NotFound';

// ADS
import LandingSST from './pages/LandingSST';
import LandingRRHH from './pages/LandingRRHH';
import TestVulnerabilidad from './pages/TestVulnerabilidad';

// CALI
import LandingSSTCali from './pages/LandingSSTCali';
import LandingRRHHCali from './pages/LandingRRHHCali';

// PASAPORTES
import Vulpix from './pages/Vulpix';
import Eevee from './pages/Eevee';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};

const AppContent = () => {
  const location = useLocation();

  const [scrolled, setScrolled] = useState(false);
  const [language, setLanguage] = useState('es');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'es' ? 'en' : 'es'));
  };

  const commonProps = { language };

  const currentPath = location.pathname.toLowerCase();

  const isPetPassport =
    currentPath === '/vulpix' ||
    currentPath.startsWith('/vulpix/') ||
    currentPath === '/eevee' ||
    currentPath.startsWith('/eevee/');

  return (
    <>
      <ScrollToTop />

      <div className="font-sans antialiased overflow-x-hidden bg-white min-h-screen flex flex-col">

        {!isPetPassport && (
          <Navbar
            scrolled={scrolled}
            language={language}
            toggleLanguage={toggleLanguage}
          />
        )}

        <main className="flex-grow relative">
          <div className="relative z-10">
            <Routes>

              <Route path="/" element={<Home {...commonProps} />} />
              <Route path="/home" element={<Home {...commonProps} />} />

              <Route path="/vulpix" element={<Vulpix />} />
              <Route path="/eevee" element={<Eevee />} />

              <Route path="/blog" element={<Blog {...commonProps} />} />
              <Route path="/blog/:slug" element={<Blog {...commonProps} />} />

              <Route path="/contacto" element={<Contacto {...commonProps} />} />

              <Route
                path="/trabaja-con-nosotros"
                element={<TrabajaConNosotros {...commonProps} />}
              />

              <Route
                path="/vacante/:slug"
                element={<TrabajaConNosotros {...commonProps} />}
              />

              <Route path="/politica" element={<Politica {...commonProps} />} />

              <Route
                path="/servicios"
                element={<PortafolioServicios {...commonProps} />}
              />

              <Route
                path="/estructura-organizacional"
                element={<EstructuraOrganizacional {...commonProps} />}
              />

              <Route
                path="/juridico"
                element={<Juridico {...commonProps} />}
              />

              <Route
                path="/nomina"
                element={<Nomina {...commonProps} />}
              />

              <Route
                path="/recursos-humanos"
                element={<RecursosHumanos {...commonProps} />}
              />

              <Route
                path="/seleccion-personal"
                element={<SeleccionPersonal {...commonProps} />}
              />

              <Route
                path="/servicios-independientes"
                element={<ServiciosIndependientes {...commonProps} />}
              />

              <Route
                path="/sst"
                element={<SST {...commonProps} />}
              />

              <Route
                path="/cotizador"
                element={<Cotizador {...commonProps} />}
              />

              <Route
                path="/cotizador/:service"
                element={<Cotizador {...commonProps} />}
              />

              <Route
                path="/sst-premium"
                element={<LandingSST {...commonProps} />}
              />

              <Route
                path="/talento-pyme"
                element={<LandingRRHH {...commonProps} />}
              />

              <Route
                path="/test-vulnerabilidad"
                element={<TestVulnerabilidad {...commonProps} />}
              />

              <Route
                path="/cali/sst"
                element={<LandingSSTCali {...commonProps} />}
              />

              <Route
                path="/cali/recursos-humanos"
                element={<LandingRRHHCali {...commonProps} />}
              />

              <Route path="/:slug" element={<Blog {...commonProps} />} />

              <Route path="*" element={<NotFound {...commonProps} />} />

            </Routes>
          </div>
        </main>

        {!isPetPassport && (
          <Footer language={language} />
        )}

        {!isPetPassport && (
          <a
            href="https://wa.me/573114044203?text=Hola%20Zaphy"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-[100] group flex items-center justify-center p-3 bg-[#25D366] text-white rounded-full shadow-2xl transition-all duration-300 animate-bounce hover:animate-none hover:scale-110"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-8 h-8"
            >
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
            </svg>
          </a>
        )}

      </div>
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
};

export default App;